var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c("el-card", { attrs: { bordered: false, shadow: "never" } }, [
        _c(
          "div",
          { staticClass: "padding-add" },
          [
            _c(
              "el-form",
              {
                attrs: { inline: "", size: "small", "label-position": "right" },
                nativeOn: {
                  submit: function ($event) {
                    $event.preventDefault()
                  },
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "任务名称：" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入任务名称", clearable: "" },
                      model: {
                        value: _vm.queryParams.taskName,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryParams, "taskName", $$v)
                        },
                        expression: "queryParams.taskName",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "任务状态：" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "请选择状态", clearable: "" },
                        model: {
                          value: _vm.queryParams.taskStatus,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryParams, "taskStatus", $$v)
                          },
                          expression: "queryParams.taskStatus",
                        },
                      },
                      [
                        _c("el-option", { attrs: { label: "启用", value: 1 } }),
                        _c("el-option", { attrs: { label: "禁用", value: 0 } }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "hasPermi",
                            rawName: "v-hasPermi",
                            value: ["platform:task:taskDefinition:list"],
                            expression: "['platform:task:taskDefinition:list']",
                          },
                        ],
                        attrs: { type: "primary" },
                        on: { click: _vm.handleQuery },
                      },
                      [_vm._v("搜索")]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "hasPermi",
                            rawName: "v-hasPermi",
                            value: ["platform:task:taskDefinition:list"],
                            expression: "['platform:task:taskDefinition:list']",
                          },
                        ],
                        on: { click: _vm.resetQuery },
                      },
                      [_vm._v("重置")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "el-card",
        {
          staticClass: "table-card mt14",
          attrs: { "body-style": { padding: "20px" } },
        },
        [
          _c(
            "div",
            { staticClass: "table-header" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "hasPermi",
                      rawName: "v-hasPermi",
                      value: ["platform:task:taskDefinition:create"],
                      expression: "['platform:task:taskDefinition:create']",
                    },
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.handleAdd },
                },
                [_vm._v("新增任务")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: { data: _vm.taskList, size: "small", border: "" },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "taskName",
                  label: "任务名称",
                  align: "center",
                  "min-width": "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "taskUrl",
                  label: "任务链接",
                  align: "center",
                  "min-width": "200",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "dailyLimit",
                  label: "每日限制次数",
                  align: "center",
                  width: "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "rewardPoints",
                  label: "奖励积分",
                  align: "center",
                  width: "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "remark",
                  label: "任务描述",
                  align: "center",
                  "min-width": "200",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "taskStatus",
                  label: "状态",
                  align: "center",
                  width: "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type:
                                scope.row.taskStatus === 1 ? "success" : "info",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  scope.row.taskStatus === 1 ? "启用" : "禁用"
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "创建时间",
                  align: "center",
                  width: "180",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  align: "center",
                  width: "200",
                  fixed: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: ["platform:task:taskDefinition:update"],
                                expression:
                                  "['platform:task:taskDefinition:update']",
                              },
                            ],
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleUpdate(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: ["platform:task:taskDefinition:delete"],
                                expression:
                                  "['platform:task:taskDefinition:delete']",
                              },
                            ],
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDelete(scope.row)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("el-pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.total > 0,
                expression: "total > 0",
              },
            ],
            attrs: {
              total: _vm.total,
              "current-page": _vm.queryParams.page,
              "page-size": _vm.queryParams.limit,
              "page-sizes": [20, 30, 50],
              layout: "total, sizes, prev, pager, next, jumper",
            },
            on: {
              "update:currentPage": function ($event) {
                return _vm.$set(_vm.queryParams, "page", $event)
              },
              "update:current-page": function ($event) {
                return _vm.$set(_vm.queryParams, "page", $event)
              },
              "update:pageSize": function ($event) {
                return _vm.$set(_vm.queryParams, "limit", $event)
              },
              "update:page-size": function ($event) {
                return _vm.$set(_vm.queryParams, "limit", $event)
              },
              "size-change": _vm.getList,
              "current-change": _vm.getList,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.open,
            width: "700px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.open = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "任务名称", prop: "taskName" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入任务名称" },
                    model: {
                      value: _vm.form.taskName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "taskName", $$v)
                      },
                      expression: "form.taskName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "任务链接", prop: "taskUrl" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入任务链接" },
                    model: {
                      value: _vm.form.taskUrl,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "taskUrl", $$v)
                      },
                      expression: "form.taskUrl",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "每日限制", prop: "dailyLimit" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 1, placeholder: "请输入每日限制次数" },
                    model: {
                      value: _vm.form.dailyLimit,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "dailyLimit", $$v)
                      },
                      expression: "form.dailyLimit",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "奖励积分", prop: "rewardPoints" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 0, placeholder: "请输入奖励积分" },
                    model: {
                      value: _vm.form.rewardPoints,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "rewardPoints", $$v)
                      },
                      expression: "form.rewardPoints",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "任务描述", prop: "remark" } },
                [
                  _c("el-input", {
                    attrs: { type: "textarea", placeholder: "请输入任务描述" },
                    model: {
                      value: _vm.form.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "remark", $$v)
                      },
                      expression: "form.remark",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "任务状态", prop: "taskStatus" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.taskStatus,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "taskStatus", $$v)
                        },
                        expression: "form.taskStatus",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("启用")]),
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("禁用")]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submitForm } },
                [_vm._v("确 定")]
              ),
              _c("el-button", { on: { click: _vm.cancel } }, [_vm._v("取 消")]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }